export default __webpack_public_path__ + "static/media/voices-of-dracula.a5957478.jpg";